// extracted by mini-css-extract-plugin
export default {"headerComponentWrapper":"Header_headerComponentWrapper__+4+Gb","sidebar_menu_icon_wrapper":"Header_sidebar_menu_icon_wrapper__8jWfB","logoWrapper":"Header_logoWrapper__XqB2e"};